<div class="performer-management-container">
  <!-- Header with filters similar to orders -->
  <div class="mobile-order-controls">
    <div class="mobile-top-row">
      <div class="mobile-filter-buttons">
        <button
          mat-icon-button
          class="refresh-button"
          (click)="refreshData()"
          matTooltip="Refresh"
        >
          <mat-icon>refresh</mat-icon>
        </button>

        @if (canExport) {
        <button mat-icon-button matTooltip="Export Data" (click)="openExportDialog()">
          <mat-icon>get_app</mat-icon>
        </button>
        } @if (canAddPerformer && !isActivityCheck) {
        <button mat-raised-button color="primary" (click)="openAddPerformerDialog()">
          <mat-icon>add</mat-icon>
          Add Performer
        </button>
        }
      </div>

      <div class="col-filter-right">
        <div class="search-part">
          <mat-form-field appearance="outline" class="search-field">
            <input
              matInput
              [value]="searchTerm"
              (input)="onSearchInput($event)"
              [placeholder]="
                searchType === 'performer_id'
                  ? 'Search by Performer ID'
                  : 'Search by Performer Name'
              "
            />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>

        <!-- Group filter -->
        @if (!isRoleBasedUser) {
        <div class="mobile-filter-buttons search-group-part">
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Filter by Group</mat-label>
            <mat-select [(ngModel)]="selectedGroupFilter" (selectionChange)="applyFilter()">
              @for (group of referralGroups; track group) {
              <mat-option [value]="group.value">
                {{ group.label }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
      </div>
    </div>
  </div>

  <!-- Table Container with your existing styling -->
  <div class="table-container">
    <div class="table-inner">
      <mat-table [dataSource]="dataSource" class="facilities-table" matSort>
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
          <mat-cell *matCellDef="let performer">
            <div class="clinic-name">
              {{ performer.name }}
            </div>
          </mat-cell>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
          <mat-cell *matCellDef="let performer">
            <div class="action-buttons">
              @if (!canEditPerformer) {
              <span class="filler"></span>
              } @if (canEditPerformer) {
              <mat-icon
                class="has-link"
                matTooltip="Edit Performer"
                (click)="editPerformer(performer)"
              >
                edit
              </mat-icon>
              }

              <span class="action-spacer"></span>

              @if (canDeletePerformer) {
              <mat-icon
                class="has-link"
                matTooltip="Delete Performer"
                (click)="deletePerformer(performer)"
                style="color: #f44336"
              >
                delete
              </mat-icon>
              } @if (!canDeletePerformer) {
              <span class="filler"></span>
              }
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns; trackBy: trackByid"></mat-row>
      </mat-table>

      <!-- Loading spinner -->
      @if (isLoading) {
      <mat-spinner></mat-spinner>
      }

      <!-- No data message -->
      @if (!isLoading && dataSource.data.length === 0) {
      <div class="text-center" style="padding: 40px">
        <mat-icon style="font-size: 48px; color: #ccc">inbox</mat-icon>
        <p>
          {{
            selectedGroupFilter
              ? 'No facilities found for the selected group'
              : 'Select a Referral Group'
          }}
        </p>
      </div>
      }
    </div>

    <!-- Paginator with your styling -->
    <div class="custom-paginator">
      <div class="grow"></div>
      <div class="custom-paginator_options-hold">
        <span>Items per page:</span>
        <mat-select
          [(ngModel)]="pageSize"
          (selectionChange)="
            onPageChange({ pageIndex: 0, pageSize: pageSize, length: totalItems })
          "
        >
          @for (option of pageSizeOptions; track option) {
          <mat-option [value]="option">{{ option }}</mat-option>
          }
        </mat-select>
        <span style="margin: 0 20px">
          {{ (currentPage - 1) * pageSize + 1 }} –
          {{ Math.min(currentPage * pageSize, totalItems) }} of {{ totalItems }}
        </span>
        <button
          mat-icon-button
          [disabled]="currentPage === 1"
          (click)="onPageChange({ pageIndex: 0, pageSize: pageSize, length: totalItems })"
        >
          <mat-icon>first_page</mat-icon>
        </button>
        <button
          mat-icon-button
          [disabled]="currentPage === 1"
          (click)="
            onPageChange({
              pageIndex: currentPage - 2,
              pageSize: pageSize,
              length: totalItems
            })
          "
        >
          <mat-icon>chevron_left</mat-icon>
        </button>
        <button
          mat-icon-button
          [disabled]="currentPage * pageSize >= totalItems"
          (click)="
            onPageChange({ pageIndex: currentPage, pageSize: pageSize, length: totalItems })
          "
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
        <button
          mat-icon-button
          [disabled]="currentPage * pageSize >= totalItems"
          (click)="
            onPageChange({
              pageIndex: Math.ceil(totalItems / pageSize) - 1,
              pageSize: pageSize,
              length: totalItems
            })
          "
        >
          <mat-icon>last_page</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
